import { http } from "@/lib/api";

const KEY = "mock-exam";

export const loadMock = () => JSON.parse(localStorage.getItem(KEY) || "null");
export const saveMock = (m) => localStorage.setItem(KEY, JSON.stringify(m));
export const clearMock = () => localStorage.removeItem(KEY);

const shuffle = (a) => a.map((x) => [Math.random(), x]).sort((p, q) => p[0] - q[0]).map((p) => p[1]);

export const createMock = async (count) => {
  const { data } = await http.get("/cases");
  const pool = shuffle(data.filter((c) => c.source !== "ai"));
  const picked = [];
  const domains = new Set();
  for (const c of pool) {
    if (picked.length === count) break;
    if (!domains.has(c.domain)) { picked.push(c); domains.add(c.domain); }
  }
  const m = { id: Date.now().toString(36), stations: picked.map(({ id, title, domain }) => ({ id, title, domain })), jobs: {}, results: {}, started_at: new Date().toISOString() };
  saveMock(m);
  return m;
};

export const recordStation = (caseId, jobId) => {
  const m = loadMock();
  if (!m) return;
  const i = m.stations.findIndex((s, k) => s.id === caseId && !m.jobs[k]);
  if (i >= 0) m.jobs[i] = jobId;
  saveMock(m);
};

export const nextStation = (m) => m.stations.findIndex((_, i) => !m.jobs[i]);

export const safeVotes = (r) => (r.examiners || []).filter((e) => e.safe).length;

// ANZCA rules (8 stations): mean >=50%, >=6/8 stations >=50%, >=13/16 examiners "safe"; scaled for half days.
export const overall = (results, n) => {
  const rs = Object.values(results).filter(Boolean);
  const avg = Math.round(rs.reduce((s, r) => s + r.overall_score, 0) / rs.length);
  const passed = rs.filter((r) => r.overall_score >= 50).length;
  const safe = rs.reduce((s, r) => s + safeVotes(r), 0);
  const needPassed = Math.ceil((n * 6) / 8);
  const needSafe = Math.ceil((n * 2 * 13) / 16);
  const rules = [
    { key: "score", label: "Overall score of 50% or more across the exam", value: `${avg}%`, ok: avg >= 50 },
    { key: "stations", label: `Pass at least ${needPassed} of ${n} vivas (50%+ each)`, value: `${passed} of ${n}`, ok: passed >= needPassed },
    { key: "safety", label: `At least ${needSafe} of ${n * 2} examiners deem you safe for independent rural anaesthesia practice`, value: `${safe} of ${n * 2}`, ok: safe >= needSafe },
  ];
  return { avg, rules, pass: rules.every((r) => r.ok) };
};
